import { ref } from 'vue'

const isOpen = ref(false)

export function useManageAuthorisationModal() {
  const openManageAuthorisationModal = () => {
    isOpen.value = true
  }

  const closeManageAuthorisationModal = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    openManageAuthorisationModal,
    closeManageAuthorisationModal,
  }
}
